module.exports = __webpack_public_path__ + "resource/static/img/icon7@1.5x.84e9d73.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon7@1.5x.png
// module id = wgGH
// module chunks = 1